<template>
  <div class="home-plans-container">

    <section class="home-plans-title-parent">
      <div class="home-plans-title-child">
        <h1>{{ $t('home-page.plans.get-more-title') }}
          <span class="premium">
            <img class="icon" src="../assets/images/SVG/plan_premium_logo_SVG.svg" alt="">
            {{ $t('plans.premium-title') }}</span>
        </h1>
      </div>
      <span class="advantages"><img class="icon" src="@/assets/images/icon_up.svg" alt="">{{ $t('home-page.plans.upgrade-anytime') }}</span>
      <span class="advantages"><img class="icon" src="@/assets/images/icon_cancel.svg" alt="">{{ $t('home-page.plans.cancel-anytime') }}</span>
    </section>

    <section class="home-plans-parent">
      <HomePlans :planName="$t('plans.basic-title')"/>

      <div class="home-plans-pro-parent">
        <HomePlans :planName="$t('plans.pro-title')" />
      </div>

      <HomePlans :planName="$t('plans.master-title')" />
    </section>

    <h2>{{ $t('home-page.plans.know-more') }}<a href="/pricing"><span>{{ $t('actions.learn-more') }}</span></a></h2>

    <section class="home-try-parent">

      <div class="home-try-child">
        <h1><span class="blue">{{ $t('home-page.plans.sign-up') }}</span>{{ $t('home-page.plans.try') }}<span class="purple">{{ $t('seedr-title') }}</span>{{ $t('home-page.plans.free') }}</h1>
        <s-button class="button-primary-blue" btn-link="/signup">{{$t('actions.try-now')}}</s-button>
      </div>

      <div class="home-try-child">
        <span><img class="icon" src="@/assets/images/icon_cloud.svg" alt="">{{ $t('home-page.plans.connect-storage') }}</span>
        <span><img class="icon" src="@/assets/images/icon_down.svg" alt="">{{ $t('home-page.plans.download-instantly') }}</span>
      </div>

    </section>

  </div>
</template>
<script>

import HomePlans from '@/components/HomePlans.vue'
import SButton from "@/components/SButton.vue";

export default {
  name: 'HomePlansContainer',
  components: {
    SButton,
    HomePlans
  },
  props: {},
  data: function () {
    return {}
  }
}
</script>
